<template>
    <PublicLayout id="app-auth">
        <Logo class="align-items-center my-2 my-md-5 my-lg-7"/>
        <ForgotPasswordForm/>
        <CertifiedLogos class="certified-logos my-5 py-5 flex-column"/>
    </PublicLayout>
</template>

<script>
import Logo from "@/components/Logo";
import CertifiedLogos from "@/components/CertifiedLogos";
import {name} from "@/config/app";
import ForgotPasswordForm from "@/shared/authentication/ForgotPasswordForm";

export default {
    name: "ForgotPassword",
    middleware: 'guest',
    meta: {
        title: `Forgot Password - ${name}`
    },
    components: {CertifiedLogos, Logo, ForgotPasswordForm},

}
</script>

<style lang="scss">
#app-auth {
    .navbar-brand {
        svg {
            width: 250px;
            height: auto;

            @include media-breakpoint-down('sm') {
                width: 200px;
            }
        }
    }

    .certified-logos {
        margin-bottom: 1rem;

        strong {
            margin-bottom: 1rem;
        }

        img {
            &:first-child {
                margin-left: 0 !important;
            }
        }
    }
}
</style>